import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { mocApi } from '../api/client';
import { fmtDate, CategoryBadge, StatusBadge } from '../lib/mocUtils';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, CheckSquare } from '@phosphor-icons/react';

export default function Validations() {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { mocApi.listValidations().then(setItems); }, []);

  const decide = async (id, ok) => {
    setBusy(id);
    const res = ok ? await mocApi.approveMoc(id) : await mocApi.rejectMoc(id, 'Renvoyée pour révision');
    setBusy(null);
    if (res.ok) {
      setItems((list) => list.filter((x) => x.id !== id));
      toast.success(ok ? `MOC ${id} approuvée` : `MOC ${id} renvoyée`);
    } else toast.error(res.error || "L'action a échoué");
  };

  return (
    <div className="space-y-5">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">En attente de décision</div>
        <h1 className="font-display text-3xl font-black tracking-tight mt-1">Mes validations</h1>
      </div>

      {!items ? <Skeleton /> : items.length === 0 ? (
        <EmptyBox icon={CheckSquare} text="Aucune validation en attente." />
      ) : (
        <div className="space-y-3">
          {items.map((v) => (
            <Card key={v.id} data-testid={`validation-${v.id}`} className="rounded-sm p-4">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-mono text-xs text-muted-foreground">{v.id}</span>
                    <CategoryBadge category={v.category} />
                    <StatusBadge status={v.status} />
                  </div>
                  <button onClick={() => navigate(`/moc/${v.id}`)} className="font-semibold text-sm mt-1 hover:text-primary text-left">{v.title}</button>
                  <div className="text-xs text-muted-foreground mt-1">Votre rôle : {v.role} · demandé le {fmtDate(v.requestedAt)}</div>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" data-testid={`approve-${v.id}`} disabled={busy === v.id} onClick={() => decide(v.id, true)}><CheckCircle size={16} weight="bold" className="mr-1.5" />Approuver</Button>
                  <Button size="sm" variant="outline" data-testid={`reject-${v.id}`} disabled={busy === v.id} onClick={() => decide(v.id, false)}><XCircle size={16} weight="bold" className="mr-1.5" />Renvoyer</Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}

export const Skeleton = () => <div className="space-y-3">{[1, 2, 3].map((i) => <div key={i} className="h-20 bg-muted animate-pulse rounded-sm" />)}</div>;
export const EmptyBox = ({ icon: Icon, text }) => (
  <Card className="rounded-sm py-16 text-center text-muted-foreground"><Icon size={40} className="mx-auto opacity-40" /><p className="mt-3 text-sm">{text}</p></Card>
);
